/* BEGIN TFX_SLIDESHOW_OVERLAY_PAUSE
   Objectif: mettre en pause l'autoplay des slideshows uniquement quand un overlay header/cart est ouvert.
   Portee: cart drawer, burger mobile/intermediaire, dropdown header desktop.
   Dependances: slideshow.js, Symmetry 8.1.1.
   Rollback: supprimer ce fichier + son include dans layout/theme.liquid.
*/
(function () {
  if (window.__tfxSlideshowOverlayPauseInitialized) return;
  window.__tfxSlideshowOverlayPauseInitialized = true;

  const PAUSE_FLAG = 'tfxOverlayPaused';

  const getSlideshows = () => Array.from(document.querySelectorAll('slide-show'));

  const hasOpenHeaderDropdown = () => !!document.querySelector('.section-header.section-header--nav-open');
  const hasOpenMobileNav = () => document.body.classList.contains('reveal-mobile-nav');
  const hasOpenCartDrawer = () => !!document.querySelector('.js-cart-drawer[open]');

  const shouldPause = () => hasOpenCartDrawer() || hasOpenMobileNav() || hasOpenHeaderDropdown();

  const syncSlideshowState = () => {
    const pause = shouldPause();

    getSlideshows().forEach((slideshow) => {
      if (
        typeof slideshow.pauseAutoplay !== 'function'
        || typeof slideshow.resumeAutoplay !== 'function'
        || typeof slideshow.startAutoplay !== 'function'
      ) return;
      if (!slideshow.autoplayEnabled) return;

      if (pause) {
        if (!slideshow.autoplayPaused) {
          slideshow.dataset[PAUSE_FLAG] = 'true';
          slideshow.pauseAutoplay();
        }
        return;
      }

      if (slideshow.dataset[PAUSE_FLAG] === 'true') {
        delete slideshow.dataset[PAUSE_FLAG];
        if (slideshow.autoplayPaused) {
          slideshow.resumeAutoplay();
        }

        if (slideshow.autoplayPaused && slideshow.autoplayEnabled) {
          slideshow.startAutoplay();
        }
      }
    });
  };

  let rafId = 0;
  const requestSync = () => {
    if (rafId) return;
    rafId = window.requestAnimationFrame(() => {
      rafId = 0;
      syncSlideshowState();
    });
  };

  const observeAttr = (target, attributeFilter) => {
    if (!target || typeof MutationObserver === 'undefined') return null;

    const observer = new MutationObserver(requestSync);
    observer.observe(target, { attributes: true, attributeFilter });
    return observer;
  };

  const bindHeaderObservers = () => {
    document.querySelectorAll('.section-header').forEach((header) => {
      if (header.dataset.tfxSlideshowOverlayObserved === 'true') return;
      header.dataset.tfxSlideshowOverlayObserved = 'true';
      observeAttr(header, ['class']);
    });
  };

  document.addEventListener('on:cart-drawer:after-open', requestSync);
  document.addEventListener('on:cart-drawer:after-close', requestSync);
  document.addEventListener('shopify:section:load', () => {
    bindHeaderObservers();
    requestSync();
  });
  document.addEventListener('shopify:section:unload', requestSync);
  document.addEventListener('shopify:section:select', requestSync);
  document.addEventListener('shopify:section:deselect', requestSync);
  document.addEventListener('shopify:section:reorder', requestSync);

  observeAttr(document.body, ['class']);

  const cartDrawer = document.querySelector('.js-cart-drawer');
  observeAttr(cartDrawer, ['open']);

  bindHeaderObservers();
  requestSync();
})();
/* END TFX_SLIDESHOW_OVERLAY_PAUSE */
